import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-green-btn',
  templateUrl: './app-green-btn.component.html',
  styleUrls: ['./app-green-btn.component.scss']
})
export class AppGreenBtnComponent implements OnInit {
  @Input() btnText: string | undefined;
  @Input() componentId: string | undefined;
  @Input() disableBtn: boolean = false;

  @Output() clickEmitter: EventEmitter<MouseEvent> = new EventEmitter();
  constructor() { }

  ngOnInit() {
  }

  emitClick(event: MouseEvent) {
    this.clickEmitter.emit(event);
  }
}
